import _ from "lodash";
import { getOrganizationDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { getMemoizedLangFunction, getYearDurationFormat } from "Utils";
import { COURSE_TYPE } from "Teacher/routes/LearningCourses/modules/Utils";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { getSubjectsWithNoGradebook } from "GradingSetup/modules/Utils";

export const getCourseSelectionHeaders = getMemoizedLangFunction(
  ({ t, isCurriculumPYP }) => {
    const headers = [
      {
        key: "RADIO_BUTTON",
        style: {
          maxWidth: "52px",
          paddingRight: "0",
        },
      },
      {
        key: "COURSE_NAME",
        value: t("course:course_name"),
        style: {
          maxWidth: "300px",
          paddingLeft: "0",
        },
        alignment: "left",
      },
      {
        key: "COURSE_TYPE",
        value: t("course:course_type"),
        style: {
          maxWidth: "300px",
        },
        alignment: "left",
      },
      {
        key: "GRADES",
        value: t("common:grades"),
        style: {
          maxWidth: "300px",
        },
        alignment: "left",
      },
      ...(!isCurriculumPYP
        ? [
            {
              key: "SUBJECTS",
              value: t("common:subject"),
              style: {
                maxWidth: "300px",
              },
              alignment: "left",
            },
          ]
        : []),
      {
        key: "ACADEMIC_YEAR",
        value: t("common:academic_year"),
        style: {
          maxWidth: "300px",
        },
        alignment: "left",
      },
    ];

    return headers;
  }
);

export const getAcademicYearsList = ({ organizationId }) => {
  const organizationDetails = getOrganizationDetailsFromCache(organizationId);

  return _.map(organizationDetails.academicYears, academicYear => {
    const { id, startDate, endDate } = academicYear;
    return {
      label: getYearDurationFormat({ startDate, endDate }),
      value: id,
    };
  });
};

export const getCourseTypes = getMemoizedLangFunction(({ t }) => {
  return [
    {
      label: t("course:blueprint_course_plural"),
      value: COURSE_TYPE.BLUEPRINT,
    },
    {
      label: t("course:teacher_course_plural"),
      value: COURSE_TYPE.TEACHER,
    },
  ];
});

export const getSimplifiedFilterValue = ({ selectedOptions, allOptions }) => {
  if (_.isEqual(_.size(selectedOptions), _.size(allOptions))) {
    return [];
  }
  return selectedOptions;
};

export const getIsAssessmentsOptionsDisabled = ({ state }) => {
  const courseId = state.teacher.selected_class.selected_course;
  const academicYearId = getSelectedAcademicYearId(state);
  const courseGradeFilters = {
    academicYearId,
  };
  const course = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters,
  });

  const subjectType = _.get(course, "subjects.0.type", "");

  const subjectsWithoutGradebook = getSubjectsWithNoGradebook();
  return _.includes(subjectsWithoutGradebook, subjectType);
};
